import Parameter from './ParameterInput';

export default Parameter;